import { AddCommentFormData } from '@/helpers/api/commentsApi'

import { AddCommentRequest, Comment, CommentResource } from './Comment'

export const transformCommentFormDataToRequest = (
    formData: AddCommentFormData,
): AddCommentRequest => ({
    type: 'comments',
    attributes: {
        body: formData.comment,
    },
    relationships: {
        [formData.relationshipKey]: {
            data: {
                type: formData.relationshipType,
                id: formData.relationshipId,
            },
        },
    },
})

export const transformToComment = (commentResource: CommentResource): Comment => ({
    id: commentResource.id,
    body: commentResource.attributes.body,
    type: commentResource.attributes.type,
    createdAt: new Date(commentResource.attributes.createdAt),
})
